(function () {
  if (window.__tstProductInit) return;
  window.__tstProductInit = true;

  var CACHE_KEY = 'tst-data-v2';
  var CACHE_TTL = 2 * 60 * 1000;
  var pending = {};
  var PER_PAGE = 10;
  var ARROW_LEFT = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3L5 8l5 5" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';
  var ARROW_RIGHT = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M6 3l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';

  function esc(value) {
    var node = document.createElement('div');
    node.textContent = value == null ? '' : String(value);
    return node.innerHTML;
  }

  function stars(rating) {
    var value = parseFloat(rating) || 0;
    return '<span class="tst-stars" style="--rating:' + value + '" role="img" aria-label="' + value + ' out of 5 stars"></span>';
  }

  function fetchAll(base) {
    if (pending[base]) return pending[base];

    try {
      var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY));
      if (cached && cached.base === base && Date.now() - cached.time < CACHE_TTL) {
        pending[base] = Promise.resolve(cached.items);
        return pending[base];
      }
    } catch (e) {}

    pending[base] = new Promise(function (resolve) {
      var items = [];
      var separator = '&';
      function get(number, key) {
        return fetch(base + separator + (key || 'page') + '=' + number, { credentials: 'same-origin' })
          .then(function (response) { return response.text(); })
          .then(function (text) { try { return JSON.parse(text); } catch (e) { return null; } })
          .catch(function () { return null; });
      }
      get(1).then(function (first) {
        if (!first) { resolve(items); return; }
        items = items.concat(first.items || []);
        var key = 'page';
        if (first.next) {
          try {
            new URL(first.next, window.location.origin).searchParams.forEach(function (value, name) {
              if (name.indexOf('page') === 0) key = name;
            });
          } catch (e) {}
        }
        var rest = [];
        for (var number = 2; number <= (first.pages || 1); number++) rest.push(get(number, key));
        Promise.all(rest).then(function (pages) {
          pages.forEach(function (data) { if (data) items = items.concat(data.items || []); });
          try {
            sessionStorage.setItem(CACHE_KEY, JSON.stringify({ base: base, time: Date.now(), items: items }));
          } catch (e) {}
          resolve(items);
        });
      });
    });
    return pending[base];
  }

  var MAX_REVIEWS_PER_PRODUCT = 16;

  function forProduct(items, productId) {
    return items
      .filter(function (item) {
        return String(item.product_id) === String(productId);
      })
      .sort(function (a, b) {
        var dateA = a.date_iso || '';
        var dateB = b.date_iso || '';
        if (dateA !== dateB) {
          if (!dateA) return 1;
          if (!dateB) return -1;
          return dateA < dateB ? 1 : -1;
        }
        return String(a.id) < String(b.id) ? -1 : 1;
      })
      .slice(0, MAX_REVIEWS_PER_PRODUCT);
  }

  function average(reviews) {
    var sum = reviews.reduce(function (total, item) { return total + (parseFloat(item.rating) || 0); }, 0);
    return Math.round((sum / reviews.length) * 10) / 10;
  }

  function summaryHTML(reviews) {
    var avg = average(reviews);
    var buckets = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    reviews.forEach(function (item) {
      var bucket = Math.min(5, Math.max(1, Math.round(parseFloat(item.rating) || 1)));
      buckets[bucket] += 1;
    });
    var bars = '';
    for (var star = 5; star >= 1; star--) {
      var percent = Math.round((buckets[star] / reviews.length) * 100);
      bars += '<div class="tst-bar"><span>' + star + ' star</span>' +
        '<span class="tst-bar-track"><span class="tst-bar-fill" style="width:' + percent + '%"></span></span>' +
        '<span>' + buckets[star] + '</span></div>';
    }
    return '<div class="tst-product-summary">' +
      '<div class="tst-avg"><span class="tst-avg-number">' + avg.toFixed(1) + '</span>' + stars(avg) +
      '<span class="tst-avg-count">Based on ' + reviews.length + (reviews.length === 1 ? ' review' : ' reviews') + '</span></div>' +
      '<div class="tst-bars">' + bars + '</div></div>';
  }

  var VERIFIED_ICON = '<svg viewBox="0 0 20 20" width="13" height="13" aria-hidden="true"><path fill="currentColor" d="M10 0l2.4 2.1 3.2-.2 1 3 2.7 1.7-.9 3.1.9 3.1-2.7 1.7-1 3-3.2-.2L10 20l-2.4-2.1-3.2.2-1-3-2.7-1.7.9-3.1-.9-3.1 2.7-1.7 1-3 3.2.2L10 0zm-1.2 13.4l5-5-1.2-1.2-3.8 3.8-1.8-1.8-1.2 1.2 3 3z"/></svg>';

  function itemHTML(item) {
    var name = String(item.name || '');
    var sub = '';
    if (item.verified) sub += '<span class="tst-verified">' + VERIFIED_ICON + ' Verified buyer</span>';
    if (item.verified && item.location) sub += ' &middot; ';
    if (item.location) sub += esc(item.location);
    return '<article class="tst-item">' +
      '<span class="tst-avatar" aria-hidden="true">' + esc(name.charAt(0).toUpperCase()) + '</span>' +
      '<div class="tst-item-body">' +
        '<div class="tst-item-head"><strong class="tst-name">' + esc(name) + '</strong></div>' +
        (sub ? '<span class="tst-sub">' + sub + '</span>' : '') +
        (item.title ? '<h3 class="tst-headline">' + esc(item.title) + '</h3>' : '') +
        '<p class="tst-text">' + esc(item.text).replace(/\n/g, '<br>') + '</p>' +
        '<div class="tst-rating-row">' + stars(item.rating) + '<span class="tst-rating-num">' + (parseFloat(item.rating) || 0).toFixed(1) + '</span>' +
          (item.date ? '<span class="tst-date">' + esc(item.date) + '</span>' : '') + '</div>' +
      '</div></article>';
  }

  function sortReviews(reviews, mode) {
    return reviews.slice().sort(function (a, b) {
      if (mode === 'highest' || mode === 'lowest') {
        var diff = (parseFloat(b.rating) || 0) - (parseFloat(a.rating) || 0);
        if (mode === 'lowest') diff = -diff;
        if (diff) return diff;
      }
      var dateA = a.date_iso || '';
      var dateB = b.date_iso || '';
      if (dateA !== dateB) {
        if (!dateA) return 1;
        if (!dateB) return -1;
        return mode === 'oldest' ? (dateA < dateB ? -1 : 1) : (dateA < dateB ? 1 : -1);
      }
      return String(a.id) < String(b.id) ? -1 : 1;
    });
  }

  function pagerHTML(current, total) {
    if (total < 2) return '';
    var out = '<nav class="tst-pager" role="navigation" aria-label="Pagination">';
    out += current > 1
      ? '<a href="#" class="tst-pager-btn" data-tst-ppage="' + (current - 1) + '" aria-label="Previous page">' + ARROW_LEFT + '<span>Previous</span></a>'
      : '<span class="tst-pager-btn" aria-disabled="true">' + ARROW_LEFT + '<span>Previous</span></span>';
    out += '<ul class="tst-pager-list">';
    for (var number = 1; number <= total; number++) {
      var near = number === 1 || number === total || Math.abs(number - current) <= 1;
      if (!near) {
        if (number === 2 || number === total - 1) out += '<li class="tst-pager-gap">&hellip;</li>';
        continue;
      }
      out += number === current
        ? '<li><span class="tst-pager-num is-active" aria-current="page">' + number + '</span></li>'
        : '<li><a href="#" class="tst-pager-num" data-tst-ppage="' + number + '" aria-label="Page ' + number + '">' + number + '</a></li>';
    }
    out += '</ul>';
    out += current < total
      ? '<a href="#" class="tst-pager-btn" data-tst-ppage="' + (current + 1) + '" aria-label="Next page"><span>Next</span>' + ARROW_RIGHT + '</a>'
      : '<span class="tst-pager-btn" aria-disabled="true"><span>Next</span>' + ARROW_RIGHT + '</span>';
    return out + '<p class="tst-pager-status">Page ' + current + ' of ' + total + '</p></nav>';
  }

  function drawList(container) {
    var body = container.querySelector('[data-tst-list-body]');
    if (!body || !container.__tstReviews) return;
    var sorted = sortReviews(container.__tstReviews, container.__tstSort || 'newest');
    var total = Math.max(1, Math.ceil(sorted.length / PER_PAGE));
    var page = Math.min(Math.max(1, container.__tstPage || 1), total);
    container.__tstPage = page;
    var from = (page - 1) * PER_PAGE;
    var slice = sorted.slice(from, from + PER_PAGE);
    body.innerHTML = '<div class="tst-list">' + slice.map(itemHTML).join('') + '</div>' + pagerHTML(page, total);
    var showing = container.querySelector('.tst-list-toolbar .tst-showing-text');
    if (showing) showing.textContent = 'Showing ' + (from + 1) + '\u2013' + (from + slice.length) + ' of ' + sorted.length + ' results';
  }

  function renderProduct(container, all) {
    var reviews = forProduct(all, container.getAttribute('data-product-id'));
    var allUrl = container.getAttribute('data-all-url');
    var footer = '<p class="tst-product-footer"><a href="' + esc(allUrl) + '">See all customer testimonials</a></p>';
    var summarySlot = container.querySelector('[data-tst-summary]');
    var listSlot = container.querySelector('[data-tst-list-slot]');
    if (!summarySlot || !listSlot) return;

    if (!reviews.length) {
      summarySlot.innerHTML = '';
      listSlot.innerHTML = '<div class="tst-product-empty">No customer reviews for this product yet.</div>' + footer;
      return;
    }
    container.__tstReviews = reviews;
    container.__tstSort = 'newest';
    container.__tstPage = 1;
    summarySlot.innerHTML = summaryHTML(reviews);
    listSlot.innerHTML = '<h3 class="tst-list-title">Review List</h3>' +
      '<div class="tst-toolbar tst-list-toolbar">' +
        '<p class="tst-showing-text"></p>' +
        '<label class="tst-sort"><span>Sort by :</span><select data-tst-product-sort aria-label="Sort reviews">' +
          '<option value="newest">Newest</option><option value="oldest">Oldest</option>' +
          '<option value="highest">Highest rated</option><option value="lowest">Lowest rated</option></select></label>' +
      '</div>' +
      '<div data-tst-list-body></div>' + footer;
    drawList(container);
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-tst-product-sort]');
    if (!select) return;
    var container = select.closest('[data-tst-product]');
    if (!container) return;
    container.__tstSort = select.value;
    container.__tstPage = 1;
    drawList(container);
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-tst-ppage]');
    if (!link) return;
    event.preventDefault();
    var container = link.closest('[data-tst-product]');
    if (!container) return;
    container.__tstPage = parseInt(link.getAttribute('data-tst-ppage'), 10) || 1;
    drawList(container);
    var title = container.querySelector('.tst-list-title');
    if (title) title.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  function renderBadge(link, all) {
    var reviews = forProduct(all, link.getAttribute('data-product-id'));
    if (!reviews.length) return;
    link.innerHTML = stars(average(reviews)) +
      '<span class="tst-badge-text">' + average(reviews).toFixed(1) + ' (' + reviews.length +
      (reviews.length === 1 ? ' review)' : ' reviews)') + '</span>';
    link.hidden = false;
  }

  function openReviewTab(event) {
    var headers = document.querySelectorAll('.product-view-tab .tab-header');
    for (var i = 0; i < headers.length; i++) {
      if (/review/i.test(headers[i].textContent)) {
        event.preventDefault();
        headers[i].click();
        headers[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    }
    // no review tab on this page (e.g. a card badge on a collection page) -
    // let the link navigate to the product page normally
  }

  function init() {
    var containers = document.querySelectorAll('[data-tst-product]');
    var badges = document.querySelectorAll('[data-tst-badge]');
    if (!containers.length && !badges.length) return;

    var first = containers[0] || badges[0];
    var base = first.getAttribute('data-data-url');
    if (!base) return;

    badges.forEach(function (badge) { badge.addEventListener('click', openReviewTab); });

    fetchAll(base).then(function (all) {
      containers.forEach(function (container) { renderProduct(container, all); });
      badges.forEach(function (badge) { renderBadge(badge, all); });
    });
  }

  /* ---------- Write a review form ---------- */

  function setRating(rate, value) {
    rate.style.setProperty('--rating', value);
    rate.setAttribute('aria-valuenow', value);
    rate.setAttribute('data-value', value);
    var input = rate.parentNode.querySelector('[name="rating"]');
    if (input) input.value = value ? String(value) : '';
  }

  function ratingFromPointer(rate, event) {
    var box = rate.querySelector('.tst-stars').getBoundingClientRect();
    var x = Math.min(Math.max(event.clientX - box.left, 0), box.width);
    return Math.max(1, Math.ceil((x / box.width) * 10) / 2);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-tst-write]');
    if (toggle) {
      var form = toggle.closest('[data-tst-write-root]').querySelector('[data-tst-form]');
      var opening = form.hidden;
      form.hidden = !opening;
      toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening) {
        form.querySelector('[name="t"]').value = String(Date.now());
        var first = form.querySelector('[name="name"]');
        if (first) first.focus();
      }
      return;
    }
    var rate = event.target.closest('[data-tst-rate]');
    if (rate) setRating(rate, ratingFromPointer(rate, event));
  });

  document.addEventListener('mousemove', function (event) {
    var rate = event.target.closest && event.target.closest('[data-tst-rate]');
    if (rate) rate.style.setProperty('--rating', ratingFromPointer(rate, event));
  });

  document.addEventListener('mouseout', function (event) {
    var rate = event.target.closest && event.target.closest('[data-tst-rate]');
    if (rate) rate.style.setProperty('--rating', rate.getAttribute('data-value') || 0);
  });

  document.addEventListener('keydown', function (event) {
    var rate = event.target.closest && event.target.closest('[data-tst-rate]');
    if (!rate) return;
    var current = parseFloat(rate.getAttribute('data-value')) || 0;
    var next = null;
    if (event.key === 'ArrowRight' || event.key === 'ArrowUp') next = Math.min(5, (current || 0.5) + 0.5);
    if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') next = Math.max(1, (current || 1.5) - 0.5);
    if (next !== null) {
      event.preventDefault();
      setRating(rate, Math.max(1, next));
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('[data-tst-form]');
    if (!form) return;
    event.preventDefault();

    var message = form.querySelector('[data-tst-message]');
    function show(text, kind) {
      message.textContent = text;
      message.className = 'tst-form-message ' + (kind ? 'is-' + kind : '');
    }

    var rating = form.querySelector('[name="rating"]').value;
    var name = form.querySelector('[name="name"]').value.trim();
    var review = form.querySelector('[name="review"]').value.trim();
    if (!rating) { show('Please choose a star rating.', 'error'); return; }
    if (name.length < 2) { show('Please enter your name.', 'error'); return; }
    if (review.length < 10) { show('Please write a little more (at least 10 characters).', 'error'); return; }

    form.classList.add('is-sending');
    show('Sending...', '');

    fetch(form.getAttribute('data-url'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        product_id: form.getAttribute('data-product-id'),
        rating: rating,
        name: name,
        location: form.querySelector('[name="location"]').value.trim(),
        title: form.querySelector('[name="title"]').value.trim(),
        review: review,
        token: form.querySelector('[name="token"]').value,
        website: form.querySelector('[name="website"]').value,
        t: Number(form.querySelector('[name="t"]').value)
      })
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (response.ok && data.ok) {
            form.classList.add('is-sent');
            show('Thank you! Your review was received and will appear once it has been approved.', 'success');
          } else {
            show(data.error || 'Something went wrong. Please try again.', 'error');
          }
        });
      })
      .catch(function () { show('Could not send your review. Please check your connection and try again.', 'error'); })
      .then(function () { form.classList.remove('is-sending'); });
  });

  /* ---------- Personal review link from the email ---------- */

  function decodePayload(token) {
    try {
      var part = String(token).split('.')[0].replace(/-/g, '+').replace(/_/g, '/');
      while (part.length % 4) part += '=';
      return JSON.parse(decodeURIComponent(escape(atob(part))));
    } catch (e) {
      return null;
    }
  }

  function checkToken() {
    var root = document.querySelector('[data-tst-write-root]');
    if (!root) return;
    var form = root.querySelector('[data-tst-form]');
    var productId = form.getAttribute('data-product-id');
    var params = new URLSearchParams(window.location.search);
    var fromLink = params.get('review');
    var storageKey = 'tst-token:' + productId;
    var token = fromLink;
    if (!token) { try { token = localStorage.getItem(storageKey); } catch (e) {} }
    if (!token) return;

    var payload = decodePayload(token);
    if (!payload || String(payload.p) !== String(productId) || payload.x * 1000 < Date.now()) return;

    if (fromLink) { try { localStorage.setItem(storageKey, token); } catch (e) {} }
    form.querySelector('[name="token"]').value = token;
    root.hidden = false;

    var nameField = form.querySelector('[name="name"]');
    if (payload.n && !nameField.value) nameField.value = payload.n;

    if (!fromLink) return;
    var rating = parseFloat(params.get('rating'));
    var rate = form.querySelector('[data-tst-rate]');
    if (rating >= 1 && rating <= 5 && rate) setRating(rate, Math.round(rating * 2) / 2);

    var headers = document.querySelectorAll('.product-view-tab .tab-header');
    for (var i = 0; i < headers.length; i++) {
      if (/review/i.test(headers[i].textContent)) { headers[i].click(); break; }
    }
    form.hidden = false;
    form.querySelector('[name="t"]').value = String(Date.now());
    var toggle = root.querySelector('[data-tst-write]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    root.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function start() {
    init();
    checkToken();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
